import DiagnosisQuestionTemplate from '~/pages/anatomyV2/libs/components/DiagnosisQuestionTemplate'
import { DIAGNOSIS_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/diagnosisCorrectAnswers'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 5

const DiagnosisHipAnatomyV2 = (props: TPageProps) => (
  <DiagnosisQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.diagnosisHip.title"
    caseTextI18nKey="onboarding.diagnosisHip.caseText"
    options={[
      {
        key: 'hipArthritis',
        i18nKey: 'onboarding.diagnosisHip.options.hipArthritis',
      },
      {
        key: 'hipFlexors',
        i18nKey: 'onboarding.diagnosisHip.options.hipFlexors',
      },
      {
        key: 'sciaticNerve',
        i18nKey: 'onboarding.diagnosisHip.options.sciaticNerve',
      },
    ]}
    correctOptionKey={
      DIAGNOSIS_CORRECT_ANSWERS[PageId.DIAGNOSIS_HIP_ANATOMY_V2_1]!
    }
    correctTitleI18nKey="onboarding.diagnosisHip.correctTitle"
    correctExplanationI18nKey="onboarding.diagnosisHip.correctExplanation"
    incorrectTitleI18nKey="onboarding.diagnosisHip.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.diagnosisHip.incorrectExplanation"
    question="Diagnosis: hip lock case"
  />
)

export default DiagnosisHipAnatomyV2
